module.exports = __webpack_public_path__ + "static/media/portfolio6-6.30d54bcd.png";